// /components/reports/components/KindSelector.js
import React from 'react';
import { Form } from 'react-bootstrap';
import { REPORT_KINDS, REPORT_KIND_KEYS } from '../reportsEnums';

function KindSelector({ reportKind, onChange }) {
  return (
    <Form.Group controlId="reportKindSelect">
      <Form.Label>2. Select Report Kind</Form.Label>
      <Form.Select name="reportKind" value={reportKind} onChange={onChange}>
        <option value="">Choose...</option>
        {REPORT_KIND_KEYS.map((key) => (
          <option key={key} value={REPORT_KINDS[key]}>
            {REPORT_KINDS[key]}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  );
}

export default KindSelector;